module.exports = __webpack_public_path__ + "img/emoji_45.40fe3413.png";